module.exports = __webpack_public_path__ + "static/media/gavel.1aab12d8.svg";